export default __webpack_public_path__ + "static/media/art-pro-brw-3.beda7ed4.png";